export default {
  pt: {
    'contracts.contractDetailPage.contract': 'Contrato',
    'contracts.contractDetailPage.contractName': 'Contrato {{name}}',
    'contracts.contractDetailPage.contracts': 'Contratos',
    'contracts.contractDetailPage.situation': 'Situação',
    'contracts.contractDetailPage.harvestCompleted': 'colheita concluída',
    'contracts.contractDetailPage.loadsDone': 'Cargas feitas',
    'contracts.contractDetailPage.doneOfEstimated': '{{done}} de {{estimated}}',
    'contracts.contractDetailPage.incidents': 'Ocorrências',
    'contracts.contractDetailPage.customer': 'Cliente',
    'contracts.contractDetailPage.workFront': 'Frente de Trabalho',
    'contracts.contractDetailPage.producer': 'Produtor',
    'contracts.contractDetailPage.dupla': 'Dupla',
    'contracts.contractDetailPage.farm': 'Fazenda',
    'contracts.contractDetailPage.city': 'Município',
    'contracts.contractDetailPage.destination': 'Destino',
    'contracts.contractDetailPage.proportion': 'Proporção',
    'contracts.contractDetailPage.hectares': 'Hectares',
    'contracts.contractDetailPage.distance': 'KM vazio',
    'contracts.contractDetailPage.hybrid': 'Híbrido',
    'contracts.contractDetailPage.farmOnMap': 'Fazenda no mapa',
    'contracts.contractDetailPage.farmLocation': 'Local da fazenda',
    'contracts.contractDetailPage.openGoogleMaps': 'Abrir no Google Maps',
    'contracts.contractDetailPage.loadsCount': 'Cargas ({{count}})',
    'contracts.contractDetailPage.schedule': 'Início {{start}} · chega {{arrival}}',
    'contracts.contractDetailPage.noLoads': 'Sem cargas ainda. As cargas aparecem quando um ticket deste contrato é aprovado.',
    'contracts.contractDetailPage.status.contract.active': 'Em andamento',
    'contracts.contractDetailPage.status.contract.closed': 'Finalizado',
    'contracts.contractDetailPage.status.shipment.draft': 'Rascunho',
    'contracts.contractDetailPage.status.shipment.awaiting_harvest': 'Aguardando colheita',
    'contracts.contractDetailPage.status.shipment.loading': 'Carregando',
    'contracts.contractDetailPage.status.shipment.awaiting_invoice': 'Aguardando nota fiscal',
    'contracts.contractDetailPage.status.shipment.awaiting_unload': 'Aguardando descarga',
    'contracts.contractDetailPage.status.shipment.unloading': 'Em descarga',
    'contracts.contractDetailPage.status.shipment.released': 'Liberada',
    'contracts.contractDetailPage.status.shipment.cancelled': 'Cancelada',
  },
  en: {
    'contracts.contractDetailPage.contract': 'Contract',
    'contracts.contractDetailPage.contractName': 'Contract {{name}}',
    'contracts.contractDetailPage.contracts': 'Contracts',
    'contracts.contractDetailPage.situation': 'Situation',
    'contracts.contractDetailPage.harvestCompleted': 'harvest completed',
    'contracts.contractDetailPage.loadsDone': 'Loads done',
    'contracts.contractDetailPage.doneOfEstimated': '{{done}} of {{estimated}}',
    'contracts.contractDetailPage.incidents': 'Incidents',
    'contracts.contractDetailPage.customer': 'Customer',
    'contracts.contractDetailPage.workFront': 'Work Front',
    'contracts.contractDetailPage.producer': 'Producer',
    'contracts.contractDetailPage.dupla': 'Pair',
    'contracts.contractDetailPage.farm': 'Farm',
    'contracts.contractDetailPage.city': 'City',
    'contracts.contractDetailPage.destination': 'Destination',
    'contracts.contractDetailPage.proportion': 'Proportion',
    'contracts.contractDetailPage.hectares': 'Hectares',
    'contracts.contractDetailPage.distance': 'Empty km',
    'contracts.contractDetailPage.hybrid': 'Hybrid',
    'contracts.contractDetailPage.farmOnMap': 'Farm on the map',
    'contracts.contractDetailPage.farmLocation': 'Farm location',
    'contracts.contractDetailPage.openGoogleMaps': 'Open in Google Maps',
    'contracts.contractDetailPage.loadsCount': 'Loads ({{count}})',
    'contracts.contractDetailPage.schedule': 'Starts {{start}} · arrives {{arrival}}',
    'contracts.contractDetailPage.noLoads': 'No loads yet. Loads appear when a ticket for this contract is approved.',
    'contracts.contractDetailPage.status.contract.active': 'In progress',
    'contracts.contractDetailPage.status.contract.closed': 'Completed',
    'contracts.contractDetailPage.status.shipment.draft': 'Draft',
    'contracts.contractDetailPage.status.shipment.awaiting_harvest': 'Awaiting harvest',
    'contracts.contractDetailPage.status.shipment.loading': 'Loading',
    'contracts.contractDetailPage.status.shipment.awaiting_invoice': 'Awaiting invoice',
    'contracts.contractDetailPage.status.shipment.awaiting_unload': 'Awaiting unloading',
    'contracts.contractDetailPage.status.shipment.unloading': 'Unloading',
    'contracts.contractDetailPage.status.shipment.released': 'Released',
    'contracts.contractDetailPage.status.shipment.cancelled': 'Cancelled',
  },
  es: {
    'contracts.contractDetailPage.contract': 'Contrato',
    'contracts.contractDetailPage.contractName': 'Contrato {{name}}',
    'contracts.contractDetailPage.contracts': 'Contratos',
    'contracts.contractDetailPage.situation': 'Situación',
    'contracts.contractDetailPage.harvestCompleted': 'cosecha completada',
    'contracts.contractDetailPage.loadsDone': 'Cargas realizadas',
    'contracts.contractDetailPage.doneOfEstimated': '{{done}} de {{estimated}}',
    'contracts.contractDetailPage.incidents': 'Incidencias',
    'contracts.contractDetailPage.customer': 'Cliente',
    'contracts.contractDetailPage.workFront': 'Frente de trabajo',
    'contracts.contractDetailPage.producer': 'Productor',
    'contracts.contractDetailPage.dupla': 'Pareja',
    'contracts.contractDetailPage.farm': 'Finca',
    'contracts.contractDetailPage.city': 'Municipio',
    'contracts.contractDetailPage.destination': 'Destino',
    'contracts.contractDetailPage.proportion': 'Proporción',
    'contracts.contractDetailPage.hectares': 'Hectáreas',
    'contracts.contractDetailPage.distance': 'KM vacío',
    'contracts.contractDetailPage.hybrid': 'Híbrido',
    'contracts.contractDetailPage.farmOnMap': 'Finca en el mapa',
    'contracts.contractDetailPage.farmLocation': 'Ubicación de la finca',
    'contracts.contractDetailPage.openGoogleMaps': 'Abrir en Google Maps',
    'contracts.contractDetailPage.loadsCount': 'Cargas ({{count}})',
    'contracts.contractDetailPage.schedule': 'Inicio {{start}} · llega {{arrival}}',
    'contracts.contractDetailPage.noLoads': 'Aún no hay cargas. Las cargas aparecen cuando se aprueba un ticket de este contrato.',
    'contracts.contractDetailPage.status.contract.active': 'En curso',
    'contracts.contractDetailPage.status.contract.closed': 'Finalizado',
    'contracts.contractDetailPage.status.shipment.draft': 'Borrador',
    'contracts.contractDetailPage.status.shipment.awaiting_harvest': 'Esperando cosecha',
    'contracts.contractDetailPage.status.shipment.loading': 'Cargando',
    'contracts.contractDetailPage.status.shipment.awaiting_invoice': 'Esperando factura',
    'contracts.contractDetailPage.status.shipment.awaiting_unload': 'Esperando descarga',
    'contracts.contractDetailPage.status.shipment.unloading': 'En descarga',
    'contracts.contractDetailPage.status.shipment.released': 'Liberada',
    'contracts.contractDetailPage.status.shipment.cancelled': 'Cancelada',
  },
}
